
import { Bounce, gsap,Back } from 'gsap';
import { BLEND_MODES, Texture } from "pixi.js";
import { ReelSymbolStates } from "../../../core/reel/symbol/ReelSpriteSymbolArea";
import { ReelSpriteSymbol } from "../../../core/reel/symbol/ReelSpriteSymbol";
import { Sequence } from '../../../core/displayobject/Sequence';
import { ISymbolAnimationConf } from "../../../core/reel/symbol/ReelBaseSymbol";
import { Helper } from "../../../core/utils/Helper";
import { ArrayHelper } from "../../../core/utils/ArrayHelper";
import { SanQuentin2 } from "../../SanQuentin2";
import { SanSymbolData } from "./SanSymbolData";
import { BasicSymbolType, ISymbolConfig } from "../../../core/reel/symbol/config/IReelSymbolStruct";
import { SanWinSymbol } from "./SanWinSymbol";
import { SimpleSpriteSwap } from '../../modules/symbol/SimpleSpriteSwap';
import { SymbolMultiplyCounter } from '../../modules/symbol/SymbolMultiplyCounter';
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';
import { SymbolData } from '../../../core/reel/symbol/config/SymbolData';
import { SanSplittedSym } from './SanSplittedSym';

export class SanSymState extends ReelSymbolStates {
    public static readonly SPLIT: string = "split";
    public static readonly SPIN_ATTENTION: string = "SPIN_ATTENTION";
}

export class SanSpriteSymbol extends ReelSpriteSymbol {

    protected splittedSym: SanSplittedSym[] = [];
    protected winSymbols: SanWinSymbol[] = [];
    protected multies: SymbolMultiplyCounter;

    protected overlaySequence:Sequence;
    protected overlaySprite: PIXI.Sprite;

    protected attentionSp_path: string = "Blink_Split";
    
    protected badgeBurn: Sequence;
    protected tl_Split: gsap.core.Timeline;

    protected jwMult: PIXI.Sprite;
    public splitAmm: number = 1;

    protected jwPopped: boolean = false;

    protected haveExpanded:boolean = false;
    protected _transformedScatter:boolean = false;

    public set transformedScatter(val:boolean) {
        this._transformedScatter = val;
    }

    public get transformedScatter(): boolean {
        return this._transformedScatter;
    }

    private get ammTextures(): number {
        return this.Splitted ? this.splittedSym.length : 1;
    }

    private get Splitted(): boolean {
        return (this.splittedSym && !!this.splittedSym.length || this.splitAmm > 1) && !this.isJumpWild;
    }

    private get SplitFucked(): boolean {
        return this.splitAmm > 4 || (this.haveExpanded && this.splitAmm == 4);
    }

    public get multiAmount(): number {
        return this.splitAmm;
    }

    public get wildExtraSplit():boolean{
        return (this.isWild || this.isJumpWild) && !!this.badgeBurn;
    }

    public get isJumpWild(): boolean {
        return this.symName == "W_J";
    }

    public get isXWays(): boolean {
        return this.symName == "XWAYS";
    }

    public get isSplit(): boolean {
        return this.symName == "XS";
    }

    public get symbolHeight(): number {
        return SanSymbolData.fetchSymHeightSize(this.sizeType.value);
    }

    public get symbolWidth(): number {
        return SanSymbolData.DEFAULT_DIM.WIDTH;
    }

    private get normalSplitTexture():PIXI.Texture{
        return SanSymbolData.getTextures(this.symName, "normal", this.splitAmm == 2 && !this.haveExpanded ? "2" : "1")![0]
    }

    private get wildSkin():string{
        return this.symName == "W" || this.splitAmm == 1 ? this.isJumpWild ? "jumping_wild" : "wild" : "default";
    }

    constructor(ID: number, symName: string, state: string = ReelSymbolStates.NORMAL, size: number = 4) {
        super(ID, symName, state, size);
        this.extraInit();
    }

    protected extraInit(): void {
        if(this.symName === "Z"){
            this.overlaySprite = this.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures("Sym_Frame_Multiplier_Bars")[0]));
            this.overlaySprite.anchor.set(0.5);
        } 
    }

    public isSpecial(value:number, durr:number = 0.2){
        this.multies = this.addChild(new SymbolMultiplyCounter());
        this.multies.addValue(value, durr);
        this.multies.position.x =  this.symbolWidth/(value >= 10 ? 4 : 3.25);
        if(this.sizeType.value != 1)
            this.multies.position.y = this.symbolHeight/(this.sizeType.value == 4 ? 3 : 4);
        this.multies.zIndex = 3000;
        this.sortableChildren = true;
    }

    jwStart():void{
        this.jwPopped = true;
    }

    public changeState(stateConfig: ISymbolAnimationConf): gsap.core.Timeline {
        if ((stateConfig.sym === "X" || this.symName === "X") && stateConfig.state === ReelSymbolStates.NORMAL) {
            stateConfig.state = ArrayHelper.getRandomValue(["normal", "normal2", "normal3", "normal4"]);
        }
        
        if (this.isJumpWild) {

            if(this.jwPopped && stateConfig.state === ReelSymbolStates.SPIN){
                if(this.jwMult) this.jwMult.visible = false;
                this._mainSprite.setTexture(SanSymbolData.getTextures(this.symbolConfig.NAME, stateConfig.state, this.sizeType.value)![0]);
            }else if(stateConfig.sizeType != 4){
                if(this.jwMult) stateConfig.state = "empty";
            }
            stateConfig.forceState = true;
        }

        return super.changeState(stateConfig);
    }

    hintValue(val:number,ways:number) {
        SanQuentin2.overlay.playValueText(this,val,ways);
    }

    playWin(hits: boolean, duration: number, winLvl: number = 0) {
        this.markNonWin(!hits, 0.5, duration/4);

        if (this.isScatter) return;
        if (hits) {
            if (this.useWinSymbol()) {
                this.winSymbols.forEach(SW => SW.Play(winLvl, duration));
                const tl = this.winSymbols[0].tlWin;
                tl.add(() => { 
                    if(this.jwMult){
                        SanQuentin2.overlay.addChild(this.jwMult);
                        this.jwMult.position = Helper.copyLocalPosition(this.jwMult,this);
                        this.jwMult.zIndex = 200;
                    }
                 }, 0)
                tl.add(() => {
                    if (this.jwMult) {
                        this.addChild(this.jwMult);
                        this.jwMult.position.set(0);
                    }
                })
                return tl;
            }
        }
    }

    public markNonWin(enable: boolean, alpha: number = 0.35, durr:number = 0.25): gsap.core.Timeline {
        this.gfxTl = Helper.setTimeline(this.gfxTl);
        this.gfxTl.to(this._darkSquareGfx, { duration: durr, alpha: enable ? alpha : 0 });
        return this.gfxTl;
    }

    public useWinSymbol(shouldBeCreated: boolean = true): boolean {
        if (!this.winSymbols.length && this._mainSprite && shouldBeCreated) {
            let sizeType = this.Splitted && !this.haveExpanded ? Math.max(1, 4 / this.splitAmm) : this.sizeType.value;
            const state = this.jwMult ? "empty" : "normal";
            for (let k = 0; k < this.ammTextures; k++){
                this.winSymbols.push(new SanWinSymbol(this.posID[0],this.symName, state , sizeType));
            }
        }

        if (this.multies && !this.isJumpWild) {
            this.winSymbols.forEach(SW => SW.isSpecial(this.multies.curAmm));
        }
           
        this.onResize();
        return !!this.winSymbols;
    }

    public NormalWildLand(): gsap.core.Timeline {
        return SanQuentin2.overlay.playSpine(this,"WS_normal",{animation:"animation",duration:0.35}).timeline;
    }

    public SetJw(multValue: number, durr: number, burnSize:number): void {
        const tl = this.fetchMainTimeline({
            onComplete: () => {
                this._mainSprite.setTexture(this._mainSprite.mainTexture);
            }
        });
        
        if(this.multies) this.multies.visible = false;

        const toConf: ISymbolConfig = SanSymbolData.getConfig("W_J");
        this.symbolConfig = toConf;
        this.state.set(multValue > 1 ? "empty" : "normal");

        tl.add(this._mainSprite.Animate({
            duration:durr,
            toTexture: SanSymbolData.getTextures(this.symbolConfig.NAME, this.state.value, this.sizeType.value)![0],
        }),0)
        
        if (multValue > 1) {
            this.splitAmm = multValue;
            this.useJWMult(multValue)
        }
    }

    jwBurnConsent(seq:Sequence):void{
        this.badgeBurn = seq;
        this.addChild(seq);
    }

    private useOverlaySequence(path:string):void{
        if(!this.overlaySequence){
            this.overlaySequence = SanQuentin2.overlay.addChild(new Sequence(SanQuentin2.assetLoader.getTextures(path)));
            this.overlaySequence.position = Helper.copyLocalPosition(this.overlaySequence,this);
            this.overlaySequence.anchor.set(0.5);
            this.overlaySequence.scale.set(1);
            this.overlaySequence.alpha = 0;
        }
    }

    // public setInteractive(val: boolean): void {
    //     if (this.currentStateAnim) {
    //         this.currentStateAnim!.interactive = val;
    //         if (val)
    //             this.currentStateAnim!.on('pointerdown', () => this.sendToMiniTable());
    //         else
    //             this.currentStateAnim!.off('pointerdown', () => this.sendToMiniTable());
    //     }
    // }

    public playBigWin(duration: number, lvl: number): void {
        if (this.isScatter) return;
        if(this.useWinSymbol()){
            this.winSymbols.forEach(s => s.BigWinStart(duration));
        }
    }

    public stopBigWin(duration: number): void {
        if (this.isScatter) return;
        if(this.useWinSymbol()){
            this.winSymbols.forEach(s => s.BigWinStop(duration));
        }
    }

    public forceSplitState(times:number):void{
        this.splitAmm = times;

        this.createNormalSplits();

        const posY:number[] = this.getNormalSplitYPos();

        this.splittedSym.forEach((s,i) => { 
            s.setTexture(this.normalSplitTexture);
            s.position.y = posY[i];
        });

        this._mainSprite.visible = false;
    }
    
    public doSplit(times:number = 2, endSplit:boolean = false, definitiveValue?:number): gsap.core.Timeline {
        if (this.symName == BasicSymbolType.SCATTER) return gsap.timeline();

        let targetValue:number = 0;

        if(definitiveValue)
            targetValue = definitiveValue;
        else
            targetValue = endSplit ?  times : times*this.splitAmm;

        if(targetValue === this.splitAmm) return gsap.timeline();
        this.splitAmm = targetValue;
        
        if(this.isJumpWild){
            this.useJWMult(this.splitAmm);
            this._mainSprite.setTexture(SanSymbolData.getTextures(this.symbolConfig.NAME, "empty", this.sizeType.value)![0]);
            return gsap.timeline();
        }

        return this.splitting();
    }

    public attentionFlash(durr: number = 0.3, tint: number = 0xFFFFFF,alpha: number = 1): gsap.core.Timeline {
        this.createFlash();
        this.overlaySequence.tint = tint;
        this.overlaySequence.play({}).fromTo(this.overlaySequence!,  { alpha: alpha }, { alpha: 0, duration:durr }, 0);
        return this.overlaySequence?.timeline!;
    }

    PlayIdle(hits: boolean, duration: number): void {
        this.markNonWin(!hits, 0.5, duration/4);

        if (this.isScatter) return;
        if (hits && this.useWinSymbol()){
            this.winSymbols.forEach(SW => SW.Idle(duration, this._mainSprite.mainTexture));
            const tl = this.winSymbols[0].tlWin;
            tl.add(() => { 
                if(this.jwMult){
                    SanQuentin2.overlay.addChild(this.jwMult);
                    this.jwMult.position = Helper.copyLocalPosition(this.jwMult,this);
                    this.jwMult.zIndex = 200;
                }
             }, 0)
            tl.add(() => {
                if (this.jwMult) {
                    this.addChild(this.jwMult);
                    this.jwMult.position.set(0);
                }
            })
        }
    }

    public setSymbol(symName: string): void{
        if ((symName === "X")) {
            this.state.set(ArrayHelper.getRandomValue(["normal", "normal2", "normal3", "normal4"]));
        }
        super.setSymbol(symName);
        if(symName == "X" && this.splittedSym){
            this.splittedSym.forEach(s => s.visible = false);
            this._mainSprite.visible = true;
        }
    }

    public onOverlayTl:gsap.core.Timeline[] = [];

    onScatterToWild(toJWInstead:boolean = false, skipped?:boolean):gsap.core.Timeline{
        this.transformedScatter = true;
        this.onOverlayTl = [];
        
        if(toJWInstead){
            this.SetJw(1,0.001,0);
        }
        else
            this.changeState({ state: ReelSymbolStates.NORMAL, sym: "W", forceState: true })

        if(skipped) return gsap.timeline();

        const tl2 = SanQuentin2.overlay.playSpine(this, toJWInstead ? "Jumping_Wild" : "Wild", 
            { animation: toJWInstead ? "transform" : "transfrorm", skinType: toJWInstead ? this.splitAmm == 1 ? "jw" : "default" : this.wildSkin}).timeline;
        const tl = SanQuentin2.overlay.playSpine(this, "S_normal", { animation: "transform", skinType:"default" }).timeline;
        
        if(this.overlaySequence){
            this.overlaySequence.stop();
            tl.to(this.overlaySequence,{alpha:0,duration:0.2},0);
        }
        this.onOverlayTl.push(tl,tl2);
        
        return tl.duration() > tl2.duration() ? tl : tl2;
    }

    onSkipped():void{
        this.onOverlayTl.forEach(tl => {
            tl.isActive() && tl.totalProgress(1);
        })
        this.onOverlayTl = [];
    }

    onScatterLands(){
        if(!this.isScatter) return gsap.timeline();
        return SanQuentin2.overlay.playSpine(this,"S_normal",{animation:"land",onStart:() => {
            this.alpha = 0;
        },
        onComplete:() => {
            this.alpha = 1;
        }
        }).timeline;
    }

    stopWin(duration: number, ignoreDarknessChange?: boolean) {
        if (this.isScatter) return;
        if (this.useWinSymbol(false)) {
            this.winSymbols.forEach(SW => SW.Stop(duration));
        }

        if (!ignoreDarknessChange)
            this.markNonWin(false, undefined, duration);
    }
    
    public attentionDarkness(duration: number = 0.2) {
        return gsap.fromTo(this._darkSquareGfx,{alpha:1} , { duration: duration, alpha: 0 });
    }

    public explodeReveal(symType:string){
        SanQuentin2.overlay.playSequence(this, SanQuentin2.assetLoader.getTextures("Mystery_Explode")).item.scale.set(2);
        this.attentionDarkness(1);
        if(this.overlaySprite) this.overlaySprite.visible = false;
        this.setSymbol(symType);
        this._mainSprite.visible = true;
    }

    private splitting(): gsap.core.Timeline {
        this.tl_Split = Helper.setTimeline(this.tl_Split, {onStart:() => {this._mainSprite.visible = false;}});

        const splitDurr: number = 0.25;
    
        this.tl_Split.add(() => { 
            this.attentionFlash(undefined, undefined, 0.5);
            const seq = (SanQuentin2.overlay.playSequence(this,SanQuentin2.assetLoader.getTextures("split")).item as Sequence);
            seq.scale.y = 2;
            seq.blendMode = BLEND_MODES.ADD;
         },0);


        if((this.haveExpanded && this.splitAmm >= 4) || this.splitAmm > 4){
            this.tl_Split.to(this,{duration:0.01},0);
            this.tl_Split.add(() => {this.createFuckedUpSplits()},0);
        }else{
            this.createNormalSplits();
            const desiredSize = SanSymbolData.fetchSymHeightSize(this.splitAmm == 2 && !this.haveExpanded ? 2 : 1);
            const symbolSize = SanSymbolData.fetchSymHeightSize(this.sizeType.value);

            const splitPos = this.getNormalSplitYPos();
            
            this.splittedSym.forEach((item, i) => {
                this.tl_Split.to(item, { y: splitPos[i], duration: splitDurr, alpha: 1 }, 0)
                this.tl_Split.add(item.Animate({
                        duration: splitDurr,
                        toTexture: this.normalSplitTexture,
                        scaling: {
                            from: new PIXI.Point(1, 1),
                            to: new PIXI.Point(1, desiredSize / symbolSize)
                        }
                    }), 0)
            });
        }
        return this.tl_Split;
    }

    private getNormalSplitYPos():number[]{

        const temp:number[] = [];

        const desiredSize = SanSymbolData.fetchSymHeightSize(this.splitAmm == 2 && !this.haveExpanded ? 2 : 1);
        const symbolSize = SanSymbolData.fetchSymHeightSize(this.sizeType.value);
        
        const totalSize = desiredSize * this.splitAmm;
        const startSize = symbolSize + (desiredSize - symbolSize);

        for(let i = 0; i < this.splittedSym.length; i++)
            temp.push(-totalSize / 2 + (desiredSize / 2) + (i * startSize));

        return temp;
    }

    createFuckedUpSplits(): void {
        let t: Texture = SanSymbolData.getTextures(this.symName, "normal", "1")![0];
        let symbolSize = SanSymbolData.fetchSymHeightSize(1);
        let totalSize = SanSymbolData.fetchSymHeightSize(this.haveExpanded ? 2 : 4) - symbolSize;
        let pieceOfTheSize = totalSize / (this.splitAmm - 1);
        let offset: number = -totalSize / 2;
        const multVal = this.multies ? this.multies.curAmm : 0;
        
        while (this.ammTextures < this.splitAmm) {
            let sp = this.addChild(new SanSplittedSym(t, multVal,this.sizeType.value));
            this.splittedSym.push(sp);
        }
        
        if (multVal) {
            this.multies.visible = false;
        }

        this.splittedSym.forEach((symbol, index) => {
            symbol.setTexturePos(1);
            symbol.position.y = offset;
            symbol.zIndex = index;
            offset += pieceOfTheSize;
            symbol.mainTexture = t;
        });
        
        this.sortChildren();
    }

    createNormalSplits(): void {
        const allowedAmount = Math.min(this.splitAmm, (4 / (this.haveExpanded ? 2 : 1))); // 4 == maximum amount
        const willSwap = this.splittedSym.length > 0 && this.splittedSym.length < allowedAmount;
        const multVal = this.multies ? this.multies.curAmm : 0;

        while (this.splittedSym.length < allowedAmount) {
           
            const texture = willSwap ? this.splittedSym[0].mainTexture : this._mainSprite.targetSwapTexture;
            const sp = this.addChild(new SanSplittedSym(texture, multVal,this.sizeType.value));
            this.splittedSym.push(sp);

            const currentLength = this.splittedSym.length;
            sp.position = this.splittedSym[(currentLength - 1) % 2].position;
        }

        if (multVal) {
            this.multies.visible = false;
        }

        if (willSwap && this.splittedSym.length > 2) {
            ArrayHelper.swapPositions(this.splittedSym, 1, 2);
        }

        this.splittedSym.forEach((s, i) => {
            s.setTexturePos(Math.max(4-this.splittedSym.length,1) );
            s.zIndex = i;
        });

        this.sortChildren();
    }

    useJWMult(Amm:number){
        if(!this.jwMult){
            this.jwMult = this.addChild(new PIXI.Sprite());
            this.jwMult.anchor.set(0.5, 0.5);
            this.sortChildren();
        }
        this.jwMult.texture = SanQuentin2.assetLoader.getTextures("JW_Multiplier/X_" + Amm)[0];
    }

    MarkedForExtraSplit(engage: boolean, burnSize?:number): gsap.core.Timeline {
        const tl = Helper.setTimeline();

        if (engage) {
            if (!this.badgeBurn) {
                this.badgeBurn = SanQuentin2.overlay.playSequence(this,SanQuentin2.assetLoader.getTextures(burnSize == 2 ? "Burning_Badge_Big" : "Burning_Badge"),{repeat:-1}).item as Sequence;
                this.badgeBurn.anchor.set(0.5);
                this.badgeBurn.blendMode = BLEND_MODES.ADD;
                if(!burnSize){
                    tl.fromTo(this.badgeBurn.scale, { x: 1.2, y: 1.2 }, { x: 1, y: 1, duration: 0.15 },0);
                    tl.fromTo(this.badgeBurn, { alpha: 0 }, { alpha: 1, duration: 0.15 },0);
                }
            }
        } else if(this.badgeBurn) {
            tl.add(SanQuentin2.overlay.playSpine(this,"Wild",{animation:"split",skinType:this.wildSkin, onStart:() => {
                if(this.jwMult){
                    SanQuentin2.overlay.addChild(this.jwMult);
                    this.jwMult.position = Helper.copyLocalPosition(this.jwMult,this);
                }
                SanQuentin2.overlay.addChild(this.badgeBurn);
                this.badgeBurn.position = Helper.copyLocalPosition(this.badgeBurn,this);
                this.badgeBurn.zIndex = 200;
            
            },onComplete:() => {
                if(this.jwMult){
                    this.addChild(this.jwMult);
                    this.jwMult.position.set(0);
                }
                this.badgeBurn.stop();
                this.badgeBurn.destroy();
                this.badgeBurn = null!;
            }}).timeline);
        }

        return tl;
    }

    public PreExtraSplit(Amm: number, setAmm:boolean = false): gsap.core.Timeline {
        this.splitAmm *= Amm;
        const tl = Helper.setTimeline();

        if(this.jwMult){
            if(setAmm){
                this.splitAmm = Amm;
                tl.to(this.jwMult,{ y:this.symbolHeight/4,ease:Back.easeOut.config(0.7) as any, duration: 0.3 },0)
            }else{
                this.jwMult.texture = SanQuentin2.assetLoader.getTextures("JW_Multiplier/X_" + this.splitAmm)[0];
                tl.fromTo(this.jwMult.scale, { x: 1, y: 1 }, { x: 1, y: 1, ease: Bounce.easeOut as any, duration: 0.15 });
            }
        }

        return tl;
    }

    expandAnimationForSplits(size: number, _duration: number, _ease: any):{to:PIXI.Point, from:PIXI.Point} | undefined {
        // Super Special case if we manage to get fuckedSplit after expansion
        if(!this.haveExpanded && this.splitAmm == 4 && !this.SplitFucked){ 
            size = 1;
        }
        let actualSize = this.isJumpWild ? 2 : Math.max(1, 4 / (this.splitAmm * (this.haveExpanded ? 2: 1)));
        if(!this.SplitFucked){

            const desiredSize = SanSymbolData.fetchSymHeightSize(this.splitAmm == 2 && !this.haveExpanded ? 2 : 1);
            const symbolSize = SanSymbolData.fetchSymHeightSize(this.sizeType.value);

            this._timeLine!.fromTo([this._darkSquareGfx.scale], { x: 1, y: 1 }, { y: 0.5 , duration: _duration, ease: _ease }, 0);
            const splitPos = this.getNormalSplitYPos();
            const texture = SanSymbolData.getTextures(this.symName, this.state.value , actualSize.toString())![0];
            this.splittedSym.forEach((item, i) => {
                item.setTexturePos(1);
                this._timeLine!.add(item.Animate({
                    duration: _duration ?? 0, 
                    toTexture: texture,
                    scaling: {
                        from: new PIXI.Point(1, 1),
                        to: new PIXI.Point(1, desiredSize / symbolSize)
                    }
                }), 0)
                this._timeLine!.to(item, { y: splitPos[i], duration: _duration, ease:_ease, }, 0)
            });
        }else{
            const symbolSize = SanSymbolData.fetchSymHeightSize(actualSize);
            const totalSize = SanSymbolData.fetchSymHeightSize(size) - symbolSize;

            const pieceOfTheSize = totalSize/(this.splitAmm-1);
    
            let startOffset = -totalSize/2;
            this._timeLine!.fromTo([this._darkSquareGfx.scale], { x: 1, y: 1 }, { y: 0.5 , duration: _duration, ease: _ease }, 0);
            this.splittedSym.forEach((item,i) => {
                this._timeLine!.to(item, { y: startOffset + (pieceOfTheSize*i), duration: _duration / 2 }, 0);
            });
        }
        
        this.sizeType.set(actualSize);

        return;
    }

    ExpandConfiguration(size: number, _duration: number, _ease: any):{to:PIXI.Point, from:PIXI.Point} | undefined {
        if (!this.sizeType.equal(size)) {
            this.haveExpanded = this.sizeType.value > size;

            if(this.Splitted) return this.expandAnimationForSplits(size,_duration,_ease);
            const currSize: number = SanSymbolData.fetchSymHeightSize(this.sizeType.value / (this.haveExpanded ? 2 : 1));
            const expectedSize: number = SanSymbolData.fetchSymHeightSize(size);

            const toScale: PIXI.Point = new PIXI.Point(1, expectedSize / currSize);
            const fromScale: PIXI.Point = new PIXI.Point(1, currSize / expectedSize);

            // JW
            if(this.jwMult){
                const toJwYPos:number = this.haveExpanded ? 0 : this.symbolHeight/3;
                this._timeLine!.to(this.jwMult, {y: toJwYPos, duration:_duration, ease: _ease},0);
            }

            if(this.multies && this.multies.visible){
                const toJwYPos:number = SanSymbolData.fetchSymHeightSize(size)/(size == 1 ? 0 : 4);
                this._timeLine!.to(this.multies, {y: toJwYPos, duration:_duration, ease: _ease},0);
            }
            // GFX
            this._timeLine!.to(this._darkSquareGfx, {  height: expectedSize , duration: _duration, ease: _ease }, 0);
            this.sizeType.set(size);
            return { from: fromScale, to: toScale};
        }
        return undefined;
    }

    public createFlash(): void {
        this.useOverlaySequence(this.attentionSp_path);
        this.overlaySequence.setTexture(this.attentionSp_path);
        this.overlaySequence.scale.set(1, 1);
        this.overlaySequence.blendMode = BLEND_MODES.ADD;
    }

    public remove(): void {
        this.winSymbols.forEach(child => { child.remove(); });
        this.winSymbols = [];
        if(this.overlaySequence) this.overlaySequence.destroy();
        this.destroy({ children: true });
    }

    public onResize(): void {
        if (this.winSymbols.length) {
            this.winSymbols.forEach((w, i) => {
                if(!w.parent) return;
                switch(this.winSymbols.length){
                     case 1:
                        w.position = Helper.copyLocalPosition(w, this)
                        break;
                    default:
                        w.position = Helper.copyLocalPosition(w, this.splittedSym[i])
                }
                w.zIndex = (w.position.x / 720) * 10 + (w.position.y / 720) * 5;
                w.parent.sortChildren();
            })
            if(!this.winSymbols[0].parent) this.winSymbols = [];
        }
    }
}
